
const state = {
  show: false,
  messageInfo: {}
}

const actions = {
  updateMessage (ctx, item) {
    ctx.commit('updateMessage', item)
  }
}

const mutations = {
  updateMessage (state, item) {
    state.messageInfo = item
  },
  showAddMessage (state, item) {
    state.show = item
  }
}

export default{
  namespaced: true,
  state,
  actions,
  mutations
}
